import React, { useEffect } from 'react';

// Import React Router
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";

// Import components
import FranchiseInfoRequest from './InfoRequest.tsx';
import FranchiseHero from './components/FranchiseHero.tsx';
import FranchiseIntro from './components/FranchiseIntro.tsx';
import FranchiseIndustry from './components/FranchiseIndustry.tsx';
import FranchiseStory from './components/FranchiseStory.tsx';
import FranchiseLocations from './components/FranchiseLocations.tsx';
import FranchiseInvestment from './components/FranchiseInvestment.tsx';
import { Helmet } from 'react-helmet';
import analyticsService from '../services/AnalyticsService.ts';

import './Franchise.css';

const FranchiseMainPage = () => {
  useEffect(() => {
    // Track franchise main page view
    analyticsService.trackPageView({
      page_title: 'Franchising',
      page_path: window.location.pathname,
      page_category: 'franchise',
      content_type: 'franchise_main'
    });

    // Set user properties for franchise interest
    analyticsService.setUserProperties({
      has_viewed_franchising: 'true',
      franchise_page_engagement: 'true',
      last_business_page_viewed: 'franchising'
    }, 'behavioral');
  }, []);

  return (
    <main className="franchise-page">
      <Helmet>
        <title>Sweetspot Cannabis Dispensary | Franchising</title>
        <meta charSet="utf-8" />
        <meta name="description" content="Join the fast-growing cannabis industry with a Sweetspot Cannabis dispensary franchise. Become part of our successful dispensary network." />
        <meta name="keywords" content="cannabis franchise, marijuana dispensary franchise, cannabis business opportunity, dispensary investment, Sweetspot franchise" />
        <meta property="og:title" content="Sweetspot Cannabis Dispensary | Franchising" />
        <meta property="og:description" content="Join the fast-growing cannabis industry with a Sweetspot Cannabis dispensary franchise. Discover investment opportunities today." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://sweetspotfarms.com/franchising" />
      </Helmet>
      <FranchiseHero />
      <FranchiseIntro />
      <FranchiseIndustry />
      <FranchiseStory />
      <FranchiseLocations />
      <FranchiseInvestment />
    </main>
  );
};

function Franchise() {
  return (
    <Routes>
      <Route path="info-request" element={<FranchiseInfoRequest />} />
      <Route path="/" element={<FranchiseMainPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default Franchise;
